(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vole-cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.getElementById('voleCartDrawer');
    if (!drawer) return;

    var ADD = drawer.getAttribute('data-cart-add');
    var CHANGE = drawer.getAttribute('data-cart-change');
    var CART_URL = drawer.getAttribute('data-cart-url');
    var CATALOG = drawer.getAttribute('data-catalog');
    var THRESHOLD = parseInt(drawer.getAttribute('data-gift-threshold'), 10) || 0;

    var panel = drawer.querySelector('.vole-drawer__panel');
    var linesEl = drawer.querySelector('[data-lines]');
    var emptyEl = drawer.querySelector('[data-empty]');
    var footEl = drawer.querySelector('[data-foot]');
    var upsellEl = drawer.querySelector('[data-upsell]');
    var upsellListEl = drawer.querySelector('[data-upsell-list]');
    var totalEl = drawer.querySelector('[data-total]');
    var giftEl = drawer.querySelector('[data-gift]');
    var giftMsg = drawer.querySelector('[data-gift-msg]');
    var giftBar = drawer.querySelector('[data-gift-bar]');
    var lastFocus = null;

    var POOL = [];
    try {
      var poolEl = drawer.querySelector('[data-upsell-pool]');
      if (poolEl) POOL = JSON.parse(poolEl.textContent) || [];
    } catch (err) { POOL = []; }

    function money(cents) {
      return (cents / 100).toLocaleString('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' zł';
    }

    function openDrawer() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      // force reflow so the transition runs
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (panel) panel.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        drawer.hidden = true;
      }, 420);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function updateCount(count) {
      document.querySelectorAll('.vole-header__count').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      var cartLink = document.querySelector('.vole-header__cart');
      if (cartLink && count > 0 && !cartLink.querySelector('.vole-header__count')) {
        var sup = document.createElement('sup');
        sup.className = 'vole-header__count';
        sup.textContent = count;
        cartLink.appendChild(sup);
      }
    }

    function renderGift(total) {
      if (!THRESHOLD || !giftEl) return;
      giftEl.hidden = false;
      var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
      if (giftBar) giftBar.style.width = pct + '%';
      if (giftMsg) {
        if (total >= THRESHOLD) {
          giftMsg.innerHTML = 'Prezent VOLE dodany do zamówienia ✦';
        } else {
          giftMsg.innerHTML = 'Do <b>prezentu VOLE</b> brakuje ' + money(THRESHOLD - total);
        }
      }
    }

    function render(cart) {
      updateCount(cart.item_count);
      if (!cart.items || cart.items.length === 0) {
        linesEl.innerHTML = '';
        emptyEl.hidden = false;
        footEl.hidden = true;
        if (upsellEl) upsellEl.hidden = true;
        if (giftEl) giftEl.hidden = true;
        return;
      }
      emptyEl.hidden = true;
      footEl.hidden = false;
      if (upsellEl) upsellEl.hidden = false;

      linesEl.innerHTML = cart.items.map(function (item, idx) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="" loading="lazy">'
          : '';
        var variant = (item.product_has_only_default_variant || !item.variant_title)
          ? ''
          : '<div class="vole-drawer__line-variant">' + item.variant_title + '</div>';
        return (
          '<li class="vole-drawer__line" data-line="' + (idx + 1) + '">' +
            '<a class="vole-drawer__line-media" href="' + item.url + '">' + img + '</a>' +
            '<div>' +
              '<a class="vole-drawer__line-title" href="' + item.url + '">' + item.product_title + '</a>' +
              variant +
              '<div class="vole-drawer__line-qty">' +
                '<button type="button" data-change="dec" aria-label="Mniej">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-change="inc" aria-label="Więcej">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="vole-drawer__line-right">' +
              '<span class="vole-drawer__line-price">' + money(item.final_line_price) + '</span>' +
              '<button type="button" class="vole-drawer__line-remove" data-remove>Usuń</button>' +
            '</div>' +
          '</li>'
        );
      }).join('');

      if (totalEl) totalEl.textContent = money(cart.total_price);
      renderGift(cart.total_price);
      renderUpsell(cart);
    }

    function upsellCard(item) {
      var thumb = item.image
        ? '<span class="vole-drawer__upsell-thumb"><img src="' + item.image + '" alt="" loading="lazy"></span>'
        : '<span class="vole-drawer__upsell-thumb"></span>';
      var tag = item.tagline ? '<small>' + item.tagline + '</small>' : '';
      return (
        '<div class="vole-drawer__upsell-item">' +
          thumb +
          '<a class="vole-drawer__upsell-info" href="' + item.url + '">' +
            '<strong>' + item.title + '</strong>' + tag +
          '</a>' +
          '<button type="button" class="vole-drawer__upsell-add" data-upsell-add="' + item.variantId + '">' +
            'Dodaj za ' + money(item.price) +
          '</button>' +
        '</div>'
      );
    }

    function paintUpsell(list, cartIds) {
      var filtered = list.filter(function (p) {
        return p && p.variantId && p.available !== false && cartIds.indexOf(p.id) === -1;
      }).slice(0, 3);
      if (!upsellEl || !upsellListEl) return;
      if (!filtered.length) {
        upsellEl.hidden = true;
        return;
      }
      upsellEl.hidden = false;
      upsellListEl.innerHTML = filtered.map(upsellCard).join('');
    }

    function mapRec(p) {
      if (!p || !p.variants || !p.variants.length) return null;
      var v = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available) { v = p.variants[i]; break; }
      }
      if (!v) return null;
      return {
        id: p.id,
        variantId: v.id,
        title: p.title,
        price: p.price,
        url: p.url,
        tagline: p.type || '',
        available: true,
        image: p.featured_image || (p.images && p.images[0]) || ''
      };
    }

    function renderUpsell(cart) {
      if (!upsellEl) return;
      var cartIds = (cart.items || []).map(function (i) { return i.product_id; });
      var base = (cart.items && cart.items.length) ? cart.items[cart.items.length - 1].product_id : null;
      if (!base) { paintUpsell(POOL, cartIds); return; }
      fetch('/recommendations/products.json?product_id=' + base + '&intent=complementary&limit=6', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var recs = (d.products || []).map(mapRec).filter(Boolean);
          paintUpsell(recs.length ? recs : POOL, cartIds);
        })
        .catch(function () { paintUpsell(POOL, cartIds); });
    }

    function addVariant(variantId, btn) {
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Dodaję…'; }
      return fetch(ADD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function () { return fetchCart(); })
        .then(function (cart) { render(cart); })
        .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
    }

    function fetchCart() {
      return fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    function changeLine(line, quantity) {
      return fetch(CHANGE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(render);
    }

    // Intercept add-to-cart forms site-wide
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      var isAdd = form.querySelector('[name="add"]') && action.indexOf('/cart/add') !== -1;
      // Skeleton product forms post to /cart/add; also catch forms with a hidden id + add button
      if (!isAdd && !(form.querySelector('[name="id"]') && form.querySelector('[name="add"]'))) return;
      e.preventDefault();
      var data = new FormData(form);
      var submitBtn = form.querySelector('[name="add"]');
      var original = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = 'Dodaję…'; }
      fetch(ADD, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          render(cart);
          openDrawer();
        })
        .catch(function () {
          window.location.href = CART_URL;
        })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = original; }
        });
    });

    // Line quantity + remove (delegated)
    linesEl.addEventListener('click', function (e) {
      var li = e.target.closest('[data-line]');
      if (!li) return;
      var line = parseInt(li.getAttribute('data-line'), 10);
      var qtyEl = li.querySelector('.vole-drawer__line-qty span');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest('[data-remove]')) {
        changeLine(line, 0);
      } else if (e.target.closest('[data-change="inc"]')) {
        changeLine(line, qty + 1);
      } else if (e.target.closest('[data-change="dec"]')) {
        changeLine(line, Math.max(0, qty - 1));
      }
    });

    // Add from upsell „Dokup do rytuału" (delegated, ajax → odświeża drawer)
    if (upsellListEl) {
      upsellListEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-upsell-add]');
        if (!btn) return;
        var variantId = btn.getAttribute('data-upsell-add');
        if (variantId) addVariant(variantId, btn);
      });
    }

    // Open from header cart link (progressive enhancement)
    document.querySelectorAll('.vole-header__cart').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(function (cart) {
          render(cart);
          openDrawer();
        });
      });
    });

    // Close handlers
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
